<template>
  <a-modal
    :visible="visible"
    :title="isActive ? `Editar cola - ${queue.name}` : `Activar cola - ${queue.name}`"
    :body-style="{ height: 'calc(100vh - 200px)', padding: '10px 24px' }"
    width="728px"
    centered
    :keyboard="false"
    :mask-closable="false"
    :class="{ 'botai_modal' : current == 4 }"
    @cancel="handleConfirmationClose"
  >
    <section class="steps">
      <!-- <CustomStepper
        :value="current"
        @update:value="current = $event"
        :items="steps"
        :readonly="!isActive"
      /> -->
      <a-tabs v-model:activeKey="current">
        <a-tab-pane :key="0" :tab="steps[0]">
          <div class="section--in-tabs">
            <CustomScrollbar ref="scrollToTop" height="calc(100vh - 18rem)">
              <StepInitialSettings
                ref="stepOne"
                isEdit
                :isActive="isActive"
                :queuePortfolios="queue?.portfolios"
                :idQueue="queue?.id"
                @disable="handleDisable"
                @onShowConfirmationModal="handleShowModal"
              />
            </CustomScrollbar>
          </div>
        </a-tab-pane>

        <a-tab-pane :key="1" :tab="steps[1]">
          <StepChannelSelect
            ref="stepTwo"
            @disable="handleDisable"
            @onShowConfirmationModal="handleShowModal"
          />
        </a-tab-pane>

        <!-- <a-tab-pane :key="2" :tab="steps[2]" v-if="hasTelephoneChannel"> -->
        <a-tab-pane :key="2" :tab="steps[2]">
          <CustomScrollbar height="calc(100vh - 18rem)">
            <StepCallSettings
              ref="stepThree"
              :idQueue="queue?.id"
              isEdit
              @disable="handleDisable"
              @onShowConfirmationModal="handleShowModal"
              @updateAudio="fileAudioHasChanged = true"
            />
          </CustomScrollbar>
        </a-tab-pane>

        <a-tab-pane :key="3" :tab="steps[3]">
          <StepUserSelection
            ref="stepFour"
            isEdit
            :isActive="isActive"
            @disable="handleDisable"
            @onShowConfirmationModal="handleShowModal"
            @updateQueue="handleUpdateQueue"
            @keep-editing="loading = false"
            class="editor-user"
          />
        </a-tab-pane>
        <a-tab-pane :key="4" :tab="steps[4]" class="tab-4" v-if="validateQueueBeexAI()">
          <StepBeexAIMessage
            ref="stepFive"
            :idQueue="queue?.id"
            isEdit
            :isActive="isActive"
            @disable="handleDisable"
            @onShowConfirmationModal="handleShowModal"
            @updateQueue="handleUpdateQueue"
            @keep-editing="loading = false"
          />
        </a-tab-pane>
      </a-tabs>
    </section>

    <!-- <section class="section">
      <component
        :is="view"
        ref="step"
        :key="keyComponent"
        v-bind="currentProperties"
        @disable="handleDisable"
        @onShowConfirmationModal="handleShowModal"
        @updateQueue="handleUpdateQueue"
      />
    </section> -->
    <template v-slot:footer>
      <a-divider class="divider" type="horizontal" />
      <div class="footer__container">
        <div class="footer__left">
          <div v-if="view == 'step-user-selection'">
            <a-button type="primary" ghost @click="handleUpdateUsers">Actualizar datos</a-button>

            <p class="footer__button">Actualizando datos en {{ countToUpdate }} segundos</p>
          </div>
        </div>
        <div class="footer__right">
          <a-button @click="handleConfirmationClose"> Cancelar </a-button>
          <a-button type="primary" :loading="loading" :disabled="disabled" @click="handleOk">
            Guardar cambios
          </a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
// import CustomStepper from "@/app/shared/components/organisms/CustomStepper";
// import StepNsTime from "@/app/queues/components/steps/StepNsTime";
// import StepQueuesTransfer from "@/app/queues/components/steps/StepQueuesTransfer";
import StepBeexAIMessage from "@/app/queues/components/steps/StepBeexAIMessage.vue";
import StepInitialSettings from "@/app/queues/components/steps/StepInitialSettings.vue";
import StepUserSelection from "@/app/queues/components/steps/StepUserSelection.vue";
import StepCallSettings from "@/app/queues/components/steps/StepCallSettings.vue";
import StepChannelSelect from "@/app/queues/components/steps/StepChannelSelect.vue";
import { QueuesEvent } from "@/app/queues/domain/events";
import EventBus from "@/app/shared/utils/eventBus";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";
import IconIAIntegrationSmall from "@/app/common/components/atoms/IconIAIntegrationSmall.vue";
import { defineComponent, createVNode, onMounted, provide, ref, h, computed, watch } from "vue";
import { useStore } from "vuex";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

// const steps = ["Conf. general", "Canales", "Conf. llamadas", "Usuarios",h('span', { class: 'step-label-beexai' }, [
//     h(IconIAIntegrationSmall, { active: true }),
//     'BotAI Message',
//   ])];
// const lastStep = steps.length - 1;
const initialStep = 0;
const TIME_TO_UPDATE = 5;

export default defineComponent({
  components: {
    // CustomStepper,
    StepInitialSettings,
    StepUserSelection,
    StepCallSettings,
    // StepNsTime,
    // StepQueuesTransfer,
    StepChannelSelect,
    CustomScrollbar,
    StepBeexAIMessage,
  },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
    queue: {
      required: false,
      type: Object,
      default: null,
    },
    isActive: {
      required: true,
      type: Boolean,
    },
  },
  setup() {
    let updateIntervalId = null;

    const countToUpdate = ref(TIME_TO_UPDATE);
    provide("countToUpdate", countToUpdate);
    const enableUsersPriority = ref(false);
    provide("enableUsersPriority", enableUsersPriority);
    
    const store = useStore();

    watch(
      () => store.getters["getQueueState"].enable_users_priority,
      (value) => {
        enableUsersPriority.value = value;
      },
      { immediate: true }
    )

    onMounted(() => {
      updateIntervalId = setInterval(() => {
        countToUpdate.value = countToUpdate.value - 1;

        if (countToUpdate.value === 0) countToUpdate.value = TIME_TO_UPDATE;
      }, 1000);
    });

    return {
      countToUpdate,
      updateIntervalId,
    };
  },
  data() {
    return {
      current: initialStep,
      initialStep,
      // lastStep,
      // steps,
      campaigns: [],
      showConfirmModal: false,
      disabled: true,
      keyComponent: 0,
      loading: false,
      fileAudioHasChanged: false,
    };
  },
  async created() {
    // this.channels = await fetchCustomerChannels();
    EventBus.$on(QueuesEvent.QUEUE_MODAL_EDIT_OPENED, () => {
      this.showConfirmModal = false;
      this.keyComponent++;
    });
  },
  methods: {
    validateQueueBeexAI() {
      // if (this.queue?.queue_beexai && this.queue?.queue_beexai.length > 0) {
      //   return true;
      // }
      return false; // se deshabilita la sección de BotAI Message en la edición de colas
    },
    async handleOk() {
      this.loading = true;

      try {
        await this.$refs?.stepOne?.handleOk(this.current);
        await this.$refs?.stepTwo?.handleOk(this.current);
        await this.$refs?.stepThree?.handleOk(this.current);
        await this.$refs?.stepFour?.handleOk(this.current);
        if (this.validateQueueBeexAI() ) await this.$refs?.stepFive?.handleOk(this.current);
        await this.handleUpdateQueue();
      } catch (error) {
        console.error(error, "error edit queue");
        const errorMessage = error?.getErrorMessage?.() || "Ha ocurrido un error";

        this.$message.error(errorMessage);
      }

      this.loading = false;
      // if (!this.isActive) {
      //   if (current == this.lastStep + 1) {
      //   }
      //   this.current = current;
      // } else if (current != undefined) {
      //   this.handleUpdateQueue();
      // }
    },
    async handleUpdateQueue() {
      await this.$store.dispatch("updateQueue", this.queue.id);

      if (this.fileAudioHasChanged) {
        await this.$store.dispatch("uploadAudioFileQueue", { id: this.queue.id });
      }

      this.$emit("update");
      this.handleClose();
      this.$message.success(`Se ha actualizado la cola “${this.queue.name}” correctamente`);
    },
    handlePrevious() {
      if (this.current === 0) {
        this.handleConfirmationClose();
      } else {
        this.current = this.current - 1;
      }
    },
    handleDisable(value) {
      this.disabled = value;
    },
    handleCancel() {
      this.handleConfirmationClose();
    },
    handleClose() {
      this.$store.dispatch("resetQueueState");
      this.current = 0;
      this.$refs?.step?.handleReset?.();
      this.$emit("onClose");
    },
    handleShowModal() {
      this.showConfirmModal = true;
    },
    handleConfirmationClose() {
      if (this.showConfirmModal) {
        Modal.confirm({
          title: "¿Deseas descartar los cambios realizados?",
          content: "Recuerda que si no guardas los cambios registrados, estos se perderán.",
          width: 450,
          icon: createVNode(QuestionCircleOutlined),
          onOk: () => this.handleClose(),
          centered: true,
          okText: "Sí, descartar cambios",
          cancelText: "No, seguir editando",
        });
      } else {
        this.handleClose();
      }
    },
    async handleUpdateUsers() {
      const id = this.portfolio[0];
      if (id) await this.$store.dispatch("fetchAgentsQueue", id);
      this.countToUpdate = TIME_TO_UPDATE;
    },
  },
  computed: {
    steps() {
      if(this.validateQueueBeexAI()) return ["Conf. general", "Canales", "Conf. llamadas", "Usuarios",h('span', { class: 'step-label-beexai' }, [
        h(IconIAIntegrationSmall, { active: this.current == 4 }),
        'BotAI Message',
      ])];
      return  ["Conf. general", "Canales", "Conf. llamadas", "Usuarios"];
    },
    lastStep() {
      return this.steps.length;
    },
    currentProperties() {
      return { isActive: this.isActive, isEdit: true, queuePortfolios: this.queue?.portfolios };
    },
    view() {
      const views = this.validateQueueBeexAI() ? [
        "step-initial-settings",
        "step-channel-select",
        "step-call-settings",
        "step-user-selection",
        "step-beex-ai-message",
      ] : [
        "step-initial-settings",
        "step-channel-select",
        "step-call-settings",
        "step-user-selection",
      ];
      return views[this.current];
    },
    visible() {
      return this.value;
    },
    okText() {
      if (!this.isActive) {
        if (this.current === this.lastStep) return "Finalizar";
        return "Continuar";
      }
      return "Guardar";
    },
    cancelText() {
      if (!this.isActive) {
        if (this.current === this.initialStep) return "Cancelar";
        return "Volver";
      }
      return "Cancelar";
    },
    // hasTelephoneChannel() {
    //   const channelsCustomer = this.$store.getters["getQueueState"].channels_customer;
    //   const channelsFilters = this.channels.filter((el) => channelsCustomer.includes(el.id));
    //   const hasTelephone = channelsFilters.find((el) => el.channel_id == 7);

    //   return hasTelephone ? true : false;
    // },
    portfolio() {
      return this.$store.getters["getQueueState"].portfolios;
    },
  },
  watch: {},
});
</script>

<style lang="sass" scoped>
.steps
  // margin: 24px 0
  h3
    text-align: center
    font-weight: 600
    font-size: 20px
    margin: 10px 0 20px

.section
  height: 420px
  margin: 0 40px

.section--in-tabs
  height: 420px
  min-height: 0 
  overscroll-behavior: contain

.footer__container
  display: flex
  justify-content: space-between
  align-items: center

.footer__left
  gap: 10px
  div
    display: flex
    align-items: center
    p
      margin-bottom: 0
      margin-left: 1em

.footer__right
  display: flex
  align-items: center
  gap: 10px

.divider
  background-color: $gray-7

:global(.ant-modal.botai_modal .ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn)
  background: linear-gradient(to bottom, #762ECF, #f73ea8) !important
  -webkit-background-clip: text !important
  -webkit-text-fill-color: transparent !important
  display: inline-block !important
  font-weight: 600 !important
  color: transparent !important // omite estilos del tab active
  text-shadow: none !important // omite estilos del tab active

:deep(span.step-label-beexai)
  display: flex
  align-items: center
  gap: 5px

:global(.ant-modal.botai_modal .ant-modal-content)
  background: linear-gradient(to bottom, #fbefff 0%, #ffffff 30%) !important

:global(.ant-modal.botai_modal .ant-modal-header)
  background-color: transparent !important

:global(.ant-modal.botai_modal .ant-tabs .ant-tabs-ink-bar)
  background: linear-gradient(180deg, #762ECF 0%, #D62FA0 100%)

:deep(.editor-user .container .box)
  height: calc(100vh - 380px) !important

:deep(.select-channels .scroll-bar)
  max-height: calc(100vh - 520px) !important
</style>
